import React from 'react';
import './Cart.css';

const Cart = (props) => {
  const cart = props.cart;
  const total = cart.reduce((total, prd) => total + prd.salary, 0);

  return (
    <div className='cart'>
      <div className='cart-header'>
        <h3>Total user in cart: {cart.length} </h3>
      </div>
      <div className='cart-footer'>
        <h3>Total Salay</h3>
        <span className='btn btn-salary'>$ {total}</span>
      </div>
    </div>
  );
};

export default Cart;
